import Cookies from 'js-cookie';

export function isClosed(cookieKey: string, value: string): boolean {
  const values = Cookies.get(cookieKey)?.split(',') || [];

  return values.includes(value);
}
